import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const TRAINERS_DELETE_REQUEST = 'DELETE_TRAINERS_REQUEST';
export const TRAINERS_DELETE_FAILURE = 'DELETE_TRAINERS_FAILURE';
export const TRAINERS_DELETE_SUCCESS = 'DELETE_TRAINERS_SUCCESS';

export const deleteTrainer = (id) => {
    const params = [];
    params['id'] = id;
    return function(dispatch) {
        dispatch(deleteRequest());
        return axios(apiRequestOptions(apiPath.TRAINERS.DELETE, null, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(deleteSuccess(id));
                dispatch(addSuccessMessage('Trainer successfully deleted'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const deleteRequest = () => {
    return {
        type: TRAINERS_DELETE_REQUEST,
    }
};

const deleteFailure = error => {
    return {
        type: TRAINERS_DELETE_FAILURE,
        error,
    }
};

const deleteSuccess = trainer => {
    return {
        type: TRAINERS_DELETE_SUCCESS,
        trainer,
    }
};